import { createPopper } from '@popperjs/core'

export const TooltipPlugin = (ref1, ref2, offset) => {
  return createPopper(ref1, ref2, offset);
}